import { Column } from "./Column";
import { Row } from "./Row";
import { TextComponent } from './TextComponent';
interface CardProps {
    title: string;
    text?: string;
    icon?: JSX.Element;
    onClick?: () => void;
    icon2?: JSX.Element;
    className?: string;
    variant?: string;
}
export const Card = ({ title, text, icon, onClick, icon2, className, variant }: CardProps) => {
    return (
        <Row
            mainAxisAlignment="between"
            {...(icon2 ? { onClick } : {})}
            className={`flex gap-3 p-3 items-center ${variant === "pink" ? "bg-socondary hover:bg-pink/40 cursor-pointer" : "bg-grayDefault"} rounded-md ${className} transition-colors duration-300 ease-in-out`}
        >
            <Row className="gap-3 w-full">
                <Column mainAxisAlignment="center">
                    {icon}
                </Column>
                <Column
                    mainAxisAlignment="center"
                    className="flex-grow overflow-hidden whitespace-normal break-words"
                >
                    <TextComponent
                        variant={`${variant === "pink" ? "h4" : "h5"}`}
                        className={`${variant === "pink" ? "text-primary font-semibold" : "text-graySecondary"}`}
                    >
                        {title}
                    </TextComponent>
                    <TextComponent
                        variant={`${variant === "pink" ? "h5" : "h4"}`}
                        className={`${variant === "pink" ? "text-black" : "text-graySecondary font-semibold"}`}
                    >
                        {text}
                    </TextComponent>
                </Column>
            </Row>
            {icon2 &&
                <Column mainAxisAlignment="center" className="pr-4">
                    {icon2}
                </Column>
            }
        </Row>
    )
}
